// vendor

window.Ladies = {
    Utility: {},
    Versand: {},
}

// ts-expect-error nope
window.Widgets = {}

import "@modules/_vendor/js/jquery-2.2.4.min.js"
import "@modules/_vendor/js/jquery.easing.js"
import "@modules/_vendor/js/bootstrap.js"
import "@modules/_vendor/js/_jquery-ui.js"
import "@modules/_vendor/js/tween.js"
import "@modules/_vendor/js/mustache.min.js"
import "@modules/_vendor/css/_jquery-ui.css"

// shared
import "@modules/global/fonts.css"
import "@modules/global/loader.css"
import "@modules/global/lds-grid10.css"
import "@lds/core/themes/default.css"
import "@modules/global/lds-theme.css"
import "@modules/global/page-stripe.css"
// ---- TODO need cleaning/checking start ----
// how can this be added to geolocation only (LocatinoSelector.js)
import "@modules/global/ladies-main"
import "../util/query-parameter"
import "../util/responsive"
import "../util/Seo"
import "../tracking/tracking"
import "../login-user/user"
import "../util/Scrolling"
import "../util/generic-modal"
import "@modules/cookie-modal/cookie-modal"
import "@modules/login-user/login-notices.ts"

// TODO not global?
import "../vue-modals/no-affiliates-modal.css"

// This import fixes an esbuild module detection issue.
// Vite uses esbuild as a transformer and as a minifier (but not as a bundler)
// Because we have very old components, like jquery, bootstrap ... in _vendor,
// which contain support for commonjs require syntax (e. g. module.exports),
// esbuild detects commonjs features and thinks this imported code needs to be wrapped inside a __commonJS wrapper
// which causes jQuery not to be defined globally, causing other code to fail.
// https://github.com/evanw/esbuild/blob/36b458d144796882a78baaa40baac5f88c7694b1/internal/linker/linker.go#L1393C5-L1442C5
// this dynamic import fixes the detection and lets esbuild think this is an es module and not commonjs
/* DO NOT REMOVE THIS IMPORT */ import("./global-buildout-fix.js")
